import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const interviewMotivation = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    eventKnowledgeScore: z
      .number()
      .nullable()
      .optional()
      .describe('Score for knowledge about this event.'),

    eventExperienceScore: z
      .number()
      .nullable()
      .optional()
      .describe('Score for previous event experience and eagerness.'),

    notes: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Interviewer notes on motivation and awareness.'),

    interviewId: z.number().hidden().describe('Foreign key to Interview'),

    interview: belongsTo('Interview'),
  })
  .describe('Motivation and awareness scores from the candidate interview.')
  .as('InterviewMotivation');

export { interviewMotivation as interviewMotivationSchema };
